module.exports = __webpack_public_path__ + "img/features02.18dbb052.png";